import { Link } from "react-router-dom";
import { ArrowRight, Users, Heart } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/motion";
import Icon from "../components/Icon";
import { PROGRAMS, IMAGES } from "../data/site";

export default function WhatWeDo() {
  return (
    <>
      <PageHeader
        eyebrow="What We Do"
        title="Programs"
        subtitle="Eleven grassroots programs that care for the whole life of a family — from early childhood to elder care, from health to livelihood."
        image={IMAGES.health}
      />

      <section className="bg-brand-cream">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-24 space-y-24">
          {PROGRAMS.map((p, i) => {
            const reversed = i % 2 === 1;
            return (
              <div key={p.slug} id={p.slug} className="scroll-mt-28 grid gap-10 lg:grid-cols-2 lg:items-center">
                <Reveal className={reversed ? "lg:order-2" : ""}>
                  <div className="relative overflow-hidden rounded-3xl group">
                    <img src={p.image} alt={p.title} className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute left-5 top-5 grid place-items-center h-12 w-12 rounded-xl bg-brand-cream/90 text-brand-primary backdrop-blur">
                      <Icon name={p.icon} className="h-6 w-6" />
                    </div>
                  </div>
                </Reveal>
                <Reveal delay={0.1} className={reversed ? "lg:order-1" : ""}>
                  <span className="text-xs uppercase tracking-[0.24em] text-brand-primary">Program {String(i + 1).padStart(2, "0")}</span>
                  <h2 className="mt-4 font-serif text-3xl sm:text-4xl text-brand-ink">{p.title}</h2>
                  <p className="mt-5 text-brand-muted leading-relaxed text-lg">{p.body}</p>
                  <div className="mt-6 flex items-start gap-3 rounded-2xl border border-brand-line bg-brand-surface p-5">
                    <Users className="h-5 w-5 shrink-0 text-brand-primary mt-0.5" />
                    <p className="text-sm text-brand-muted"><span className="font-semibold text-brand-ink">Who it serves: </span>{p.serves}</p>
                  </div>
                  {/* <-- ADD REAL IMPACT STORIES HERE --> */}
                  <Link to="/get-involved#donate" className="mt-7 inline-flex items-center gap-2 rounded-full bg-brand-primary px-6 py-3 text-sm font-semibold text-brand-cream hover:bg-brand-primaryHover transition-colors">
                    <Heart className="h-4 w-4" /> Support this program
                  </Link>
                </Reveal>
              </div>
            );
          })}
        </div>
      </section>

      <section className="bg-brand-teal text-brand-cream">
        <div className="mx-auto max-w-4xl px-5 sm:px-8 py-24 text-center">
          <Reveal>
            <h2 className="font-serif text-4xl sm:text-5xl">Every program runs on generosity</h2>
            <p className="mt-6 text-brand-cream/75 leading-relaxed">Your support keeps these doors open in Thanga and across Bishnupur District.</p>
            <Link to="/get-involved#donate" data-testid="wwd-donate-btn" className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-accent px-7 py-3.5 font-semibold text-brand-ink hover:bg-[#d95a48] transition-colors">
              <Heart className="h-5 w-5" /> Donate now <ArrowRight className="h-5 w-5" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
